<script>
import LocationCard from "./LocationCard.svelte"
import { fade, slide } from "svelte/transition"

//props
export let locations = []

//vars
let current = null

//fns
const toggleCurrent = id =>
    current = current !== id
        ? id
        : null


const createLocationTree = locations => {

    // From locations we need
    // 1) list of countries
    // 2) list of states
    // 3) locations for each state

    // Locations are pre-sorted on the server, so, maintain the order
    const tree = []
    const countryMap = new Map()

    locations.forEach(loc => {

        // maybe add country
        if ( ! countryMap.has(loc.country.id) ) {
            const countryNode = {
                country: loc.country,
                html:{
                    id:`country-${loc.country.slug}`
                },
                states: [],
                stateMap: new Map()
            }
            tree.push(countryNode)
            countryMap.set(loc.country.id, countryNode)
        }

        // get country
        const countryNode = countryMap.get(loc.country.id)

        // maybe add state
        if ( ! countryNode.stateMap.has(loc.state.id) ) {
            const stateNode = {
                state: loc.state,
                html: {
                    id: `state-${loc.state.slug}`,
                    ariaControls: `${loc.state.slug}-locations`,
                },
                locations: []
            }
            countryNode.states.push(stateNode)
            countryNode.stateMap.set(loc.state.id, stateNode)
        }

        // get state
        const stateNode = countryNode.stateMap.get(loc.state.id)

        // add location
        stateNode.locations.push(loc)
    })

    console.log({ tree })
    return tree
}


// reactive
$: tree = createLocationTree(locations)
$: isExpanded = id => current === id
</script>

<div class="location-list"
     role="region"
     transition:fade>

    {#if locations.length === 0 }
        <div class="location-list__header">
            <span>No locations found</span>
        </div>
    {:else}

        <div class="location-list__accordion accordion">

            {#each tree as countryNode}

                <div class="accordion-group" role="region" aria-labelledby="{countryNode.html.id}">

                    <div class="accordion-group__title" id="{countryNode.html.id}">
                        {countryNode.country.title}
                    </div>

                    {#each countryNode.states as stateNode}
                        <div class="accordion-item">
                            <div class="accordion-header">
                                <button class="accordion-button"
                                        on:click={() => toggleCurrent(stateNode.state.id)}
                                        on:keydown={(e)=>{
								 if (e.key==='Enter'||e.key===' '){
									 e.preventDefault()
									 toggleCurrent(stateNode.state.id)
								 }
							 }}
                                        id={stateNode.html.id}
                                        class:expanded={isExpanded(stateNode.state.id)}
                                        aria-expanded={isExpanded(stateNode.state.id)}
                                        aria-controls={stateNode.html.ariaControls}
                                >
                                    <span class="accordion-button__title">{stateNode.state.title}</span>

                                    <span class="accordion-button__toggle">
                                        <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="14.21"
                                             height="8.36"
                                             viewBox="0 0 14.21 8.36">
                                            <path class="downiconpath" fill="#6a6a6a"
                                                  d="M.07,1.88A1,1,0,0,1,1,.93a.92.92,0,0,1,.68.29l5.46,5.7,5.46-5.7a1,1,0,0,1,1.36,0,1,1,0,0,1,0,1.33L7.88,9A1,1,0,0,1,6.51,9l0,0L.34,2.56A.94.94,0,0,1,.07,1.88Z"
                                                  transform="translate(-0.07 -0.93)"></path>
                                        </svg>
                                    </span>
                                </button>
                            </div>

                            {#if isExpanded(stateNode.state.id)}
                                <div class="accordion-collapse"
                                     id={stateNode.html.ariaControls}
                                     role="region"
                                     aria-labelledby={stateNode.html.id}
                                     transition:slide|local
                                >
                                    <div class="accordion-body">
                                        {#each stateNode.locations as location}
                                            <LocationCard {location}/>
                                        {/each}
                                    </div>
                                </div>
                            {/if}
                        </div>
                    {/each}
                </div>
            {/each}
        </div>
    {/if}
</div>